import React from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from '../../../../context/ThemeProvider';
import useMedia from '../../../../hooks/useMedia';

const Currencies = ({ open, activeHeader }) => {
  const { themeMode, setThemeMode } = React.useContext(ThemeContext);
  const [show, setShow] = React.useState(false);

  const isMedium = useMedia('(max-width: 991.98px) and (min-width: 767.98px)');
  const isSmall = useMedia('(max-width: 767.98px)');

  const topVal = isMedium ? 'auto' : isSmall ? 'auto' : '80px';

  const currencyes = [
    { cur: 'Грн' },
    // { cur: 'Руб' },
    { cur: 'Usd' },
    { cur: 'Eur' },
  ];

  return (
    <div
      className={
        activeHeader
          ? 'header-currency__wrapper is-scroll'
          : 'header-currency__wrapper'
      }
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
      role="presentation"
    >
      <div className="header-currency__current-wrapper">
        <span
          className={
            !show
              ? 'header-currency__current'
              : 'header-currency__current is-show'
          }
        >
          {themeMode}
        </span>
      </div>
      <div
        className={
          !show
            ? 'header-currency__all-overflow'
            : 'header-currency__all-overflow is-show'
        }
        style={{ top: activeHeader ? topVal : ' ' }}
      >
        <div
          className={
            show
              ? 'header-currency__all is-show'
              : open
              ? 'header-currency__all is-open'
              : 'header-currency__all'
          }
        >
          {currencyes.map((item, index) => {
            return (
              <button
                key={index}
                onClick={(e) => setThemeMode(item.cur)}
                className={
                  themeMode === item.cur
                    ? 'header-currency__all-button is-active'
                    : 'header-currency__all-button'
                }
              >
                {item.cur}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

Currencies.propTypes = {
  open: PropTypes.bool,
};

export default Currencies;
